import React from 'react';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { permissionCheckFnforCamo } from '../../../utils';
import { TableCell, TableRow, Tooltip } from '@material-ui/core';
const InventoryListing = ({ item, onView, onEdit, onDelete, onOpenAttachments }) => {
	return (
		<TableRow>
			<TableCell align='right'>
				<div style={{ minWidth: '120px' }}>
					<ul className='list-inline'>
						<li className='list-inline-item' onClick={onView}>
							<Tooltip title="View" arrow placement='top'>
								<VisibilityIcon fontSize='small' color='primary' style={{fontSize:"1.35rem",cursor: 'pointer' }}  />
							</Tooltip>
						</li>
						{permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" }) ? <li style={{marginInline:"3px" }} onClick={onEdit} className='list-inline-item'>
							<Tooltip title="Edit" arrow placement='top'>
								<CreateOutlinedIcon color='primary' fontSize='small' style={{fontSize:"1.35rem",cursor: 'pointer' }}  />
							</Tooltip>
						</li> : null}
						{permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) ? <li  onClick={onDelete} className='list-inline-item'>
							<Tooltip title="Delete" arrow placement='top'>
								<DeleteOutlineIcon color='secondary' style={{fontSize:"1.35rem",cursor: 'pointer' }} />
							</Tooltip>
						</li> : null}
						{item.attachments.length ?
							<li onClick={onOpenAttachments} className='list-inline-item'>
								<span className='flex-centered'>
									<Tooltip title="View Attachment" arrow placement='top'>
										<span><AttachFileIcon color='primary' fontSize='small' style={{ fontSize: "1.35rem", cursor: 'pointer' }} />({item.attachments.length})</span>
									</Tooltip>
								</span>
							</li> : null
						}
					</ul>
				</div>
			</TableCell>
			<TableCell>{item?.description || '--'}</TableCell>
			<TableCell>{item?.serial_number}</TableCell>
			<TableCell>{item?.part_number || '--'}</TableCell>
			<TableCell>{item?.owner || '--'}</TableCell>
			<TableCell>{item?.location || '--'}</TableCell>
			<TableCell>{item?.linked_asset || '--'}</TableCell>
			<TableCell>{item?.status || '--'}</TableCell>
		</TableRow>
	)
}
export default InventoryListing